import memoize from "memoize-one";
import { Board, Item } from "../types";

export function formatTimeDiff(time: number, short?: boolean): string {
    time *= 1e-3;

    // const y = Math.floor(time / (3600 *  24 * 365));
    // time = time % (3600 * 24 * 365);
    const d = Math.floor(time / (3600 * 24));
    time = time % (3600 * 24);
    const h = Math.floor(time / 3600);
    time = time % 3600;
    const m = Math.floor(time / 60);
    time = time % 60;

    let str;
    if (short) {
        if (d > 0) {
            str = `${d}d ${h}h`;
        } else if (h > 0) {
            str = `${h}h ${m}m`;
        } else {
            str = `${m}m`;
        }
    } else {
        if (d > 0) {
            str = `${d} day${d !== 1 ? "s" : ""} ${h} hour${h !== 1 ? "s" : ""}`;
        } else if (h > 0) {
            str = `${h} hour${h !== 1 ? "s" : ""} ${m} minute${m !== 1 ? "s" : ""}`;
        } else {
            str = `${m} minute${m !== 1 ? "s" : ""}`;
        }
    }

    return str;
}

export function formatFloat(number: number): number {
    return Math.round(100 * number) / 100;
}

export function formatWeight(
    value: number,
    unitTag?: (strings: TemplateStringsArray, value: number | string) => string
): string {
    try {
        const rounded = formatFloat(value).toLocaleString();
        return unitTag ? unitTag`${rounded}` : `${rounded}`;
    } catch (err) {
        return "(1)";
    }
}

export const getItemsMap = memoize((board: Board) => {
    const itemsMap: { [id: string]: Item } = {};
    board.items.forEach((item) => (itemsMap[item.id] = item));
    return itemsMap;
});

export const isEmptyObject = (o: Record<string, any>): boolean => {
    for (const i in o) {
        return false;
    }
    return true;
};

export const indexOfSmallest = (a: any[]): number => {
    let lowest = 0;
    for (let i = 1; i < a.length; i++) {
        if (a[i] < a[lowest]) lowest = i;
    }
    return lowest;
};

export const getTransparentRGB = (hex: string | undefined, alpha1?: string, alpha2?: string): string => {
    if (!hex) {
        return "#000" + (alpha1 || "0");
    }
    if (hex.length === 5) {
        // #rgbA
        return hex.slice(0, hex.length - 1) + (alpha1 || "0");
    } else if (hex.length === 9) {
        // #rrggbbAA
        return hex.slice(0, hex.length - 2) + (alpha2 || "00");
    } else if (hex.length === 4) {
        // #rgb
        return hex + (alpha1 || "0");
    } else {
        // #rrggbb
        return hex + (alpha2 || "00");
    }
};

export function sleep(ms: number): Promise<any> {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

export function isRetrospectiveTools(view: string): boolean {
    return ["replay", "cfd", "stats"].includes(view);
}

export function copyTextToClipboard(text: string): void {
    const textArea = document.createElement("textarea");
    // Place in the top-left corner of screen regardless of scroll position.
    textArea.style.position = "fixed";
    textArea.style.top = "-99999px";
    textArea.style.left = "-99999px";

    textArea.value = text;

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        document.execCommand("copy");
    } catch (err) {
        console.error("Failed to copy to clipboard: " + text);
    }

    document.body.removeChild(textArea);
}
